import { Icon } from "./Icon.tsx";

/** Axes plus a smooth, monotonic arc, distinct from HydrographIcon.tsx's
 * asymmetric peak-then-recede shape and TimeSeriesIcon.tsx's irregular
 * multi-point line. */
export function CurveIcon() {
  return (
    <Icon>
      <path d="M4 4v16h16" />
      <path d="M5 17c3-7 9-11 14-11" />
    </Icon>
  );
}
